import React, { useEffect, useState } from 'react'
import { Dropdown, Layout, Modal, Spin } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Helmet } from 'react-helmet'
import { navigate } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { isLoggedIn, isMember } from '../api/auth'
import StripeCardModal from './stripeCardModal'
import '../styles/global-version.scss'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe('pk_test_51RLoAXGmuBXaI3YthrBUWu2BrDk7DbnVN5s6jQGDilPo6tDwzft5WciBEGMRMtNfITrMHzmZZSe0iCtrpMldZItY00BxqWbgNx')

const { Header, Content, Footer } = Layout
const { confirm } = Modal
const year = new Date().getFullYear()

const greetingStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  paddingBottom: 2,
}
const headerDropdownStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  paddingBottom: 2,
  flexGrow: 1,
  justifyContent: 'flex-end',
}

export default function MainLayout(props) {
  const [firstName, setFirstName] = useState(undefined)
  const [lastName, setLastName] = useState(undefined)
  const [isCardModalVisible, setIsCardModalVisible] = useState(false)

  useEffect(() => {
    setFirstName(localStorage.getItem('firstName'))
    setLastName(localStorage.getItem('lastName'))
  }, [])

  if (!isLoggedIn() || !isMember()) {
    if (typeof window !== 'undefined') window.location.href = '/login'
  }

  return isLoggedIn() && isMember() ? (
    <Elements stripe={stripePromise}>
      <Layout style={{ background: 'white' }} className="main-layout">
        <Helmet title="Cloud Shipping" defer={false} />
        <Header className="sb-shadow bg-base">
          <div className="sb-container d-flex">
            <div style={greetingStyle} className="header-greeting">
              S.B. Express
            </div>
            <div style={headerDropdownStyle}>
              <Dropdown
                placement="bottomRight"
                className="layout-header-dropdown"
                overlayClassName="layout-header-dropdown-overlay"
                trigger={['click']}
                menu={{
                  items: [
                    {
                      key: 'card',
                      label: 'Карт',
                      onClick: () => setIsCardModalVisible(true),
                    },
                    {
                      key: 'logout',
                      label: 'Гарах',
                      onClick: () => {
                        confirm({
                          title: 'Та гарахдаа итгэлтэй байна уу?',
                          maskClosable: true,
                          icon: <ExclamationCircleOutlined />,
                          cancelText: 'Үгүй',
                          okText: 'Тийм',
                          okType: 'danger',
                          className: 'confirm-hs-modal',
                          centered: true,
                          confirmLoading: true,
                          onOk() {
                            localStorage.clear()
                            sessionStorage.removeItem('paginatedRequestData')
                            navigate('/login')
                          },
                        })
                      },
                    },
                  ],
                }}
              >
                <div className="d-flex align-items-center cursor-pointer">
                  <span className="me-2">
                    {firstName ?? ''} {lastName ?? ''}
                  </span>
                  <FontAwesomeIcon icon={faChevronDown} size="xs" />
                </div>
              </Dropdown>
            </div>
          </div>
        </Header>

        <Content>
          <div style={{ maxWidth: '1366px', margin: 'auto', padding: '20px 30px' }}>{props.children}</div>
        </Content>

        <Footer className="sb-footer text-center bg-white">ICodice, {year}</Footer>

        {/* Stripe Modal */}
        <Modal title="Карт нэмэх" open={isCardModalVisible} onCancel={() => setIsCardModalVisible(false)} footer={null} destroyOnClose>
          <StripeCardModal onClose={() => setIsCardModalVisible(false)} />
        </Modal>
      </Layout>
    </Elements>
  ) : (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Spin />
    </div>
  )
}
